module.exports = __webpack_public_path__ + "img/2x.333996d.jpg";